import * as ExcelJs from 'exceljs/dist/exceljs'

/**
 * 支持多sheet 导出excel
 * @param datas 数据，一个数组表示一个sheet中的数据
 * @param filename 文件名称
 */
export default function name(fileName, datas) {
    if (!datas.length) return;
    // 创建一个工作簿
    const workbook = new ExcelJs.Workbook()

    datas.forEach((i, index) => {
        if (i.list.length) {
            let keys = Object.keys(i.list[0]);
            let data = i.list.map(j => {
                let arr = [];
                for (const key in j) {
                    if (j.hasOwnProperty(key)) {
                        arr.push(j[key])
                    }
                }
                return arr
            })
            const ws1 = workbook.addWorksheet(i.sheetname || "sheet1")

            data.unshift(keys)
            // 表头上行插入其它信息
            if (i.headerOtherInfo) {
                i.headerOtherInfo.data.forEach((j, index) => {
                    data.unshift(j)
                })
            }
            // 表尾插入其它信息
            if (i.afterData) {
                i.afterData.data.forEach((j, index) => {
                    data.push(j)
                })
            }
            data.unshift([i.title || fileName])

            ws1.addRows(data);
            // 行居中
            rowCenter(ws1, 0, data.length, keys, i.colors, i.borders, i.autoHeight, i.textAling);
            ws1.mergeCells(1, 1, 1, keys.length);

            // 合并单元格
            i.merge && i.merge.forEach(j => {
                ws1.mergeCells(...j);
            })

            i.titleHeight = i.titleHeight || 40;
            if (i.titleHeight) {
                ws1.getRow(1).height = i.titleHeight;
                ws1.getCell('A1').alignment = {
                    vertical: 'middle',
                    // horizontal: 'center',
                    horizontal: 'left',
                    wrapText: true
                }
            }

            // 单元格解锁并加密
            if (i.lockeds && i.lockeds.length) {
                i.lockeds.forEach((j) => {
                    let column = ws1.getColumn(j);
                    column.eachCell((cell, rowNumber) => {
                        if (rowNumber > 2) {
                            cell.protection = {
                                locked: false,
                                hidden: true,
                            }
                        };
                    });
                });

                // 加密  密码 1
                ws1.protect('1', {
                    selectLockedCells: false,
                });
            }


            // 添加标题背景
            const row = ws1.getRow(i.headerOtherInfo ? i.headerOtherInfo.data.length + 2 : 2);
            keys.forEach((item, index) => {
                if (item) {
                    let node = row.getCell(index + 1)
                    // node.height = 22;
                    node.font = {
                        size: 14,
                        color: {
                            argb: 'ffffff'
                        },
                        bold: true,
                    }
                    node.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: {
                            argb: 'b20000'
                        },
                        bgColor: {
                            argb: 'b20000'
                        }
                    };
                }
            })

            keys.forEach((j, index) => {
                ws1.getColumn(index + 1).width = i.widths && i.widths[index] ? i.widths[index] : 20;
            })

            if (i.callback) {
                i.callback(ws1);
            }
        }
    })

    /**
     *  设置start-end行单元格水平垂直居中/添加边框
     * @param arg_ws workSheet 参数
     * @param arg_start 开始行
     * @param arg_end 结束结束行
     * @param colors 背景颜色
     */
    function rowCenter(arg_ws, arg_start, arg_end, keys, colors, borders, autoHeight, textAling) {
        // eslint-disable-next-line no-undef,no-unmodified-loop-condition
        let i = arg_start
        for (; i <= arg_end; i++) {
            if (arg_ws.findRow(i)) {
                arg_ws.findRow(i).alignment = {
                    vertical: 'middle',
                    horizontal: textAling || 'center',
                    wrapText: true
                }
                if (!autoHeight) arg_ws.findRow(i).height = 22
            }

            // 加边框
            const row = arg_ws.getRow(i);
            keys.forEach((item, index) => {
                let node = row.getCell(index + 1)
                node.font = {
                    size: 14,
                }
                if (borders) {
                    let c = borders[i + "-" + item]
                    if (c) {
                        node.border = {
                            top: {
                                style: 'thin'
                            },
                            left: {
                                style: 'thin'
                            },
                            bottom: {
                                style: 'thin'
                            },
                            right: {
                                style: 'thin'
                            }
                        };
                    }
                } else {
                    node.border = {
                        top: {
                            style: 'thin'
                        },
                        left: {
                            style: 'thin'
                        },
                        bottom: {
                            style: 'thin'
                        },
                        right: {
                            style: 'thin'
                        }
                    };
                }
                // 添加背景颜色
                if (colors) {
                    let c = colors[i + "-" + item]
                    if (c) {
                        node.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {
                                argb: c.bg
                            },
                            bgColor: {
                                argb: c.bg
                            }
                        };
                    }
                }
            })

        }
    }

    // 保存设置
    workbook.xlsx.writeBuffer().then(buffer => {
        // return;
        const aLink = document.createElement('a')
        var blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        aLink.href = URL.createObjectURL(blob)
        aLink.setAttribute('download', fileName + '.xlsx') // 设置下载文件名称
        document.body.appendChild(aLink)
        aLink.click()
        document.body.removeChild(aLink)
    })
}